import { REGISTERED_APPS } from '../../shared/types/Apps';
import { logInfo } from '../../shared/utils/logging';
import CandyRackDocumentListenerUtils from './candyRackDocumentListenerUtils';
import CandyRackCloningButtonsUtils from './candyRackCloningButtonsUtils';

class Buttons {
  constructor(eventName: string) {
    if (
      window.CANDYRACK_DOCUMENT_LISTENER ||
      (window.Shopify &&
        ['loverscharm.myshopify.com', 'lambertones-llc.myshopify.com'].includes(
          window.Shopify.shop,
        )) ||
      window.mwProductOptionsObjects
    ) {
      logInfo(
        'Initializing AddToCart document listener button handler',
        REGISTERED_APPS.CANDYRACK,
      );
      new CandyRackDocumentListenerUtils(eventName).setupDocumentListener();
    } else {
      logInfo(
        'Initializing AddToCart cloned buttons',
        REGISTERED_APPS.CANDYRACK,
      );
      new CandyRackCloningButtonsUtils(eventName);
    }
    logInfo('loaded buttons', REGISTERED_APPS.CANDYRACK);
  }
}

const initButtons = () => new Buttons('addToCartButtonClicked');
export default initButtons;
